import { useTheme } from "design-system/themeContext";
import React from "react";
import { Helmet } from "react-helmet-async";

import { EnergyDashboardNewMultiTab } from "../components/EnergyPerformance/EnergyDashboardNewMultiTab";

export const EnergyPerformanceNewMultiTab = () => {
  const theme = useTheme();
  return (
    <>
      <Helmet>
        <title>Energy & CO₂ | {theme.clientDisplayName}</title>
      </Helmet>
      <EnergyDashboardNewMultiTab />
    </>
  );
};
